import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const Password = ({ id, value, onChange, label = 'Password', disabled = false, error = "" }) => {
    const [selectedPassword, setSelectedPassword] = useState(value || "");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setSelectedPassword(value || "");
    }, [value]);

    const handlePasswordChange = (e) => {
        setSelectedPassword(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor={id}>{label}</label>
            <div style={{ display: "flex", alignItems: "center" }}>
                <input
                    type={visible ? "text" : "password"}
                    disabled={disabled}
                    id={id}
                    value={selectedPassword}
                    onChange={handlePasswordChange}
                    className="p-2 border rounded-md w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button
                    type="button"
                    onClick={() => setVisible(prev => !prev)}
                    style={{
                        position: "absolute",
                        right: "10px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "1.1rem"
                    }}
                    tabIndex={-1}
                >
                    {visible ? '🙈' : '👁️'}
                </button>
            </div>
            {error && <div style={{ color: 'red', fontSize: '0.8rem' }}>{error}</div>}
        </div>
    );
};

export default Password;
